import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/content/qc` — QC checks now live on Runs, so the old list URL lands filtered to QC checks. */
export const Route = createFileRoute('/_authenticated/_tenant/content/qc/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/runs', search: { type: 'qc' } });
  },
});
